import styled from "styled-components";
import { PageTitle } from "../modules/PageHeaders";
import BalanceCard, { DeliveryCard } from "./modules/BalanceCard";
import { useGetCommunicationBalancesQuery } from "../../../store/admin/communicationSlice";
import { Loading } from "../../../components";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "../../../utils";
export const Summary = () => {
  const navigate = useNavigate();
  const { data: balancesData, isLoading, error } = useGetCommunicationBalancesQuery();

  const handleTopUp = () => {
    navigate("/super_admin/dashboard");
  };

  if (isLoading) {
    return (
      <Wrapper className="mx-2 mx-lg-4">
        <PageTitle title={"Summary"} />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
          <Loading />
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper className="mx-2 mx-lg-4">
        <PageTitle title={"Summary"} />
        <div className="alert alert-danger">
          Failed to load communication balances. Please try again.
        </div>
      </Wrapper>
    );
  }

  const {
    smsBalance = 0,
    smsBalanceKobo,
    smsBalanceNaira,
    emailBalance,
    emailUnlimited = true,
    messagesSentToday = 0,
    failedMessages = 0,
    scheduledMessages = 0,
    activeGroups = 0,
  } = balancesData || {};

  const smsKoboResolved = smsBalanceKobo ?? smsBalance ?? 0;
  const smsRemainingLabel =
    smsBalanceNaira != null
      ? formatMoney(smsBalanceNaira, true)
      : formatMoney(smsKoboResolved / 100, true);

  // SMS: same source as dashboard (BranchCommunicationBalance) — show remaining only to match dashboard
  // Email: unlimited — no cap, show "Unlimited"
  return (
    <>
      <Wrapper className="mx-2 mx-lg-4">
        <PageTitle title={"Summary"} />
        <div className="balance-cards">
          <BalanceCard
            used={smsRemainingLabel}
            total={1}
            title={"SMS Balance (NGN)"}
            btnText={"Top up"}
            onClickAction={handleTopUp}
            progressBgColor={"var(--color-secondary-soft)"}
            progressBarColor={"#19BC31"}
            image={"/Icon/sms.svg"}
            showRemainingOnly
          />
          <BalanceCard
            used={emailBalance}
            total={emailBalance}
            title={"Email Balance"}
            unlimited={emailUnlimited}
            progressBgColor={"var(--color-primary-soft)"}
            progressBarColor={"var(--color-primary)"}
            image={"/Icon/emailBal.svg"}
          />
        </div>
        <div className="sent-items">
          <DeliveryCard
            title={"Messages Sent Today"}
            figure={messagesSentToday}
            image={"/Icon/smsSent.svg"}
          />
          <DeliveryCard
            title={"Failed Messages"}
            figure={failedMessages}
            image={"/Icon/smsSent.svg"}
          />
          <DeliveryCard
            title={"Scheduled Messages"}
            figure={scheduledMessages}
            image={"/Icon/smsSent.svg"}
          />
          <DeliveryCard
            title={"Communication Groups"}
            figure={activeGroups}
            image={"/Icon/smsSent.svg"}
          />
        </div>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  .balance-cards {
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 1rem;
  }
  .balance-cards > .card {
    max-width: 460px;
  }
  .balance-cards > .card:nth-child(2) {
    max-width: 310px;
  }
  .sent-items > .card {
    min-width: 300px;
  }
  .sent-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media (min-width: 768px) {
    .balance-cards {
      display: grid;
      grid-template-columns: auto auto;
      gap: 100px;
    }
    .sent-items > .card {
      max-width: 300px;
    }
  }
`;

export default Summary;
